import { Injectable } from "@angular/core";
import { MasterData } from "@core/models/master-data/master-data";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { storeMasterDataAction } from "./master.action";

export class MasterDataStoreModel{
    masterData: MasterData
}
@State<MasterDataStoreModel>({
    name: 'masterDataState',
    defaults: {
        masterData: null
     }
})
@Injectable()
export class masterDataState {

    constructor( ) {
    }

    @Selector()
    static getMasterData(state: MasterDataStoreModel) {
        return state.masterData;
    }
    @Action(storeMasterDataAction)
    storeMasterDataAction({getState, patchState}: StateContext<MasterDataStoreModel>, {payload}: storeMasterDataAction) {

        const state = getState();
        patchState({
            
            masterData:payload
        });
        // console.log(payload);
        
    }
}